import { configureStore } from '@reduxjs/toolkit';
import { Map } from 'immutable';
import { combineReducers } from 'redux-immutable';

import {
  collectEntityRequirements,
  createDuckReducerFromRequires,
  duckMiddleware,
} from '@burnsred/entity-duck';

import { axiosInstance } from '@/api';
import { settings } from '@/settings';

export const entityRequirements = collectEntityRequirements(
  import.meta.glob('./entities/**/!(*test*).ts', { eager: true }),
);

const devEntityRequirements =
  import.meta.env.DEV || import.meta.env.VITE_DEV_ENTITIES === 'true'
    ? collectEntityRequirements(
        import.meta.glob('./screens/dev/entities/*.ts', { eager: true }),
      )
    : [];

const rootReducerMap = createDuckReducerFromRequires(
  [...entityRequirements, ...devEntityRequirements],
  combineReducers,
);

export const store = configureStore({
  reducer: combineReducers(rootReducerMap),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Immutable.js values are not serializable / plain objects
      serializableCheck: false,
      immutableCheck: false,
    }).concat(duckMiddleware({ settings, client: axiosInstance })),
  preloadedState: Map(),
  // https://github.com/reduxjs/redux-devtools/blob/main/extension/docs/API/Arguments.md
  devTools: import.meta.env.DEV && { trace: true, traceLimit: 100 },
});
